import { ISize } from 'shared/types/Size';

export const transformSizeOptions = (sizeOptions: ISize[]) =>
  sizeOptions.map(({ presentation }) => ({ value: presentation, label: presentation }));
